import { render, staticRenderFns } from "./ManageReportsModal.vue?vue&type=template&id=af90e462&scoped=true&"
import script from "./ManageReportsModal.vue?vue&type=script&lang=js&"
export * from "./ManageReportsModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageReportsModal.vue?vue&type=style&index=0&id=af90e462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af90e462",
  null
  
)

export default component.exports